import type { PackMember } from '../lib/types'
import PackArtwork from './PackArtwork'

// Collage of a combo's member covers, used when the combo has no cover art of
// its own. Splits the square into one tile per member (a diagonal-ish 2-up for
// the common two-pack bundle).
export default function ComboArtwork({
  members,
  className = '',
}: {
  members: PackMember[]
  className?: string
}) {
  const tiles = members.slice(0, 4)
  if (tiles.length === 0) {
    return <div className={`w-full h-full bg-ink-soft ${className}`} />
  }

  const cols = tiles.length === 1 ? 'grid-cols-1' : 'grid-cols-2'
  return (
    <div className={`grid ${cols} gap-px bg-line w-full h-full ${className}`}>
      {tiles.map((m) => (
        <div key={m.id} className="relative overflow-hidden bg-ink-soft">
          <PackArtwork pack={{ name: m.name, image: m.image, catalog_number: null }} size="mid" />
        </div>
      ))}
    </div>
  )
}
